import { reviewConstants } from "../constants/reviewConstants";
import { reviewService } from "../../services/API/reviewService";
import { alertActions } from "./alert.actions";
import { history } from "../store/configureStore";
import Alert from "../../components/alert/Alert";

export const add_review = postData => {
  return dispatch => {
    dispatch(request());
    reviewService.add_review(postData).then(
      data => {
        dispatch(success(data));
      },
      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: reviewConstants.ADD_REVIEW_REQUEST, data };
  }
  function success(data) {
    return { type: reviewConstants.ADD_REVIEW_SUCCESS, data };
  }
  function failure(error) {
    return { type: reviewConstants.ADD_REVIEW_FAILURE, error };
  }
};

export const get_review_list = dealID => {
  return dispatch => {
    dispatch(request());
    reviewService.get_review_list(dealID).then(
      data => {
        dispatch(success(data));
      },
      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: reviewConstants.GET_REVIEW_REQUEST, data };
  }
  function success(data) {
    return { type: reviewConstants.GET_REVIEW_SUCCESS, data };
  }
  function failure(error) {
    return { type: reviewConstants.GET_REVIEW_FAILURE, error };
  }
};

export const update_review = postData => {
  return dispatch => {
    dispatch(request());
    reviewService.update_review(postData).then(
      data => {
        dispatch(success(data));
      },
      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: reviewConstants.UPDATE_REVIEW_REQUEST, data };
  }
  function success(data) {
    return { type: reviewConstants.UPDATE_REVIEW_SUCCESS, data };
  }
  function failure(error) {
    return { type: reviewConstants.UPDATE_REVIEW_FAILURE, error };
  }
};

export const get_review_details = (dealID) => {
  return dispatch => {
    dispatch(request());
    reviewService.get_review_details(dealID).then(
      data => {
        dispatch(success(data));
      },
      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: reviewConstants.GET_REVIEW_DETAILS_REQUEST, data };
  }
  function success(data) {
    return { type: reviewConstants.GET_REVIEW_DETAILS_SUCCESS, data };
  }
  function failure(error) {
    return { type: reviewConstants.GET_REVIEW_DETAILS_FAILURE, error };
  }
};

//Admin apis
export const get_review_list_for_admin = postData => {
  return dispatch => {
    dispatch(request());
    reviewService.get_review_list_for_admin(postData).then(
      data => {
        dispatch(success(data));
      },
      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: reviewConstants.GET_REVIEW_REQUEST_FOR_ADMIN, data };
  }
  function success(data) {
    return { type: reviewConstants.GET_REVIEW_SUCCESS_FOR_ADMIN, data };
  }
  function failure(error) {
    return { type: reviewConstants.GET_REVIEW_FAILURE_FOR_ADMIN, error };
  }
};

export const change_review_status = postData => {
  return dispatch => {
    dispatch(request());
    reviewService.change_review_status(postData).then(
      data => {
        dispatch(success(data));
      },
      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: reviewConstants.CHANGE_REVIEW_STATUS_REQUEST, data };
  }
  function success(data) {
    return { type: reviewConstants.CHANGE_REVIEW_STATUS_SUCCESS, data };
  }
  function failure(error) {
    return { type: reviewConstants.CHANGE_REVIEW_STATUS_FAILURE, error };
  }
};

export const delete_review = reviewID => {
  return dispatch => {
    dispatch(request());
    reviewService.delete_review(reviewID).then(
      data => {
        dispatch(success(data));
      },
      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: reviewConstants.DELETE_REVIEW_REQUEST, data };
  }
  function success(data) {
    return { type: reviewConstants.DELETE_REVIEW_SUCCESS, data };
  }
  function failure(error) {
    return { type: reviewConstants.DELETE_REVIEW_FAILURE, error };
  }
};

export const update_review_by_admin = postData => {
  return dispatch => {
    dispatch(request());
    reviewService.update_review_by_admin(postData).then(
      data => {
        dispatch(success(data));
      },
      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: reviewConstants.UPDATE_REVIEW_BY_ADMIN_REQUEST, data };
  }
  function success(data) {
    return { type: reviewConstants.UPDATE_REVIEW_BY_ADMIN_SUCCESS, data };
  }
  function failure(error) {
    return { type: reviewConstants.UPDATE_REVIEW_BY_ADMIN_FAILURE, error };
  }
};
export const get_review_details_for_admin = postData => {
  return dispatch => {
    dispatch(request());
    reviewService.get_review_details_for_admin(postData).then(
      data => {
        dispatch(success(data));
      },

      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: reviewConstants.GET_REVIEW_DETAILS_FOR_ADMIN_REQUEST, data };
  }
  function success(data) {
    return { type: reviewConstants.GET_REVIEW_DETAILS_FOR_ADMIN_SUCCESS, data };
  }
  function failure(error) {
    return {
      type: reviewConstants.GET_REVIEW_DETAILS_FOR_ADMIN_FAILURE,
      error
    };
  }
};



// WEBPACK FOOTER //
// ./src/app/redux/actions/reviewActions.js